import { Spinner } from "../theme/logos";
import { FormButton } from "../../data/style/Style";

const RequestButton = (props) => {
  let { text, onClick, activeRequest, disabled, loadingText, alt, small } =
    props;

  return (
    <FormButton onClick={onClick} disabled={disabled} alt={alt} small={small}>
      {activeRequest ? (
        <>
          <Spinner />
          &nbsp;
          {loadingText}
        </>
      ) : (
        <>{text}</>
      )}
    </FormButton>
  );
};

export default RequestButton;
